var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden","width":"100%","height":"100%"}},[_c('div',{staticClass:"random-background"},[_c('v-overlay',{attrs:{"opacity":"0.6","z-index":"0","color":"white"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }